export function employeeGrid() {
  const WIDGETS = document.querySelectorAll('.mtt-employees--default')
  if (WIDGETS.length > 0) {
    WIDGETS.forEach((WIDGET) => {
      const employeeGridClass = new EmployeeGridClass(WIDGET)
      employeeGridClass.init()
    })
  }
}

class EmployeeGridClass {
  constructor(WIDGET) {
    this.WIDGET = WIDGET
    this.CATEGORIES = this.WIDGET.querySelectorAll('.mtt-employees__filter button')
    this.SELECT = this.WIDGET.querySelector('#employee-dropdown')
    this.TARGET = this.WIDGET.querySelector('.mtt-employees__target')

    this.data = {
      categoryId: 0
    }
  }

  init () {
    if (this.CATEGORIES.length > 0) {
      this.CATEGORIES.forEach((CATEGORY) => {
        CATEGORY.addEventListener('click', () => {
          this.CATEGORIES.forEach(CAT => CAT.classList.remove('active'))
          CATEGORY.classList.add('active')
          this.data.categoryId = parseInt(CATEGORY.getAttribute('data-term-id'))
          this.doAjax()
        })
      })
    }
    if (this.SELECT) {
      this.SELECT.addEventListener('change', (e) => {
        this.data.categoryId = parseInt(e.target.value)
        this.doAjax()
      })
    }
  }

  doAjax () {
    this.WIDGET.classList.add('mtt-employees--loading')
    fetch(mtt_employees_widget.rest_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.data)
    })
      .then(response => response.json())
      .then(response => {
        this.TARGET.innerHTML = response.markup
        this.WIDGET.classList.remove('mtt-employees--loading')
      })
  }
}
